import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Collapse,
} from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";

const gbPound = new Intl.NumberFormat("en-GB", {
  style: "currency",
  currency: "GBP",
});

const ExpandableTable = ({ data }) => {
  if (!data.transactionsSummary) {
    return null;
  }

  return (
    <TableContainer component={Paper} sx={{ borderRadius: 0 }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell />
            <TableCell>Name</TableCell>
            <TableCell align="right" style={{ width: 200 }}>
              Monthly Average
            </TableCell>
            <TableCell align="right" style={{ width: 200 }}>
              Amount
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.transactionsSummary.income && (
            <ExpandableRow
              item={{
                name: "Income",
                categories: data.transactionsSummary.income.fcaCategories,
                expanded: true,
              }}
            />
          )}
          {data.transactionsSummary.expenditure && (
            <ExpandableRow
              item={{
                name: "Expenditure",
                categories: data.transactionsSummary.expenditure.fcaCategories,
                expanded: true,
              }}
            />
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const ExpandableRow = ({ item }) => {
  const [isExpanded, setIsExpanded] = useState(!!item.expanded);

  const toggleExpand = () => {
    setIsExpanded((prev) => !prev);
  };

  return (
    <>
      <TableRow>
        <TableCell style={{ width: "50px" }}>
          {item.categories && !item.expanded && (
            <IconButton size="small" onClick={toggleExpand}>
              {isExpanded ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </IconButton>
          )}
        </TableCell>
        <TableCell
          style={{
            textTransform: "capitalize",
            fontWeight: item.expanded ? "bold" : "normal",
          }}
        >
          {item.name}
        </TableCell>
        <TableCell align="right" style={{ width: 200 }}>
          {item.monthlyAverage?.value != null &&
            gbPound.format(item.monthlyAverage.value)}
        </TableCell>
        <TableCell align="right" style={{ width: 200 }}>
          {item.amount && gbPound.format(item.amount.value)}
        </TableCell>
      </TableRow>
      {isExpanded && item.categories && (
        <TableRow>
          <TableCell
            style={{ paddingBottom: 0, paddingTop: 0, paddingRight: 0 }}
            colSpan={4}
          >
            <Collapse in={isExpanded} timeout="auto" unmountOnExit>
              <Table size="small">
                <TableBody>
                  {item.categories.map((category) => (
                    <ExpandableRow key={category.id} item={category} />
                  ))}
                </TableBody>
              </Table>
            </Collapse>
          </TableCell>
        </TableRow>
      )}
    </>
  );
};

export default ExpandableTable;
